var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5822 9.03098C26.1175 9.53659 26.1416 10.3805 25.636 10.9158L15.2447 21.9184C14.213 23.0108 12.4829 23.0355 11.4204 21.973L6.39052 16.9431C5.86983 16.4224 5.86983 15.5782 6.39052 15.0575C6.91122 14.5368 7.75544 14.5368 8.27614 15.0575L13.306 20.0874L23.6973 9.08483C24.2029 8.54947 25.0468 8.52536 25.5822 9.03098Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.9f48eae5ce5e797a1d739e2bba15b853.svg";
export { ForwardRef as ReactComponent };